<script setup>
import { divIcon, latLngBounds, latLng, point, marker } from 'leaflet'
import { LMap, LMarker, LTileLayer } from '@vue-leaflet/vue-leaflet'
import { LMarkerClusterGroup } from 'vue-leaflet-markercluster'
import IndexMapLocation from './IndexMapLocation.vue'

import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref, nextTick, watch } from 'vue'

const { t } = useI18n()
const props = defineProps(['data'])
const active = ref(null)
const mapInstance = ref(null)

// @TODO: fix mobile scrolling two fingers

const options = {
  tile: {
    url: 'https://tiles.celebrare-timisoara.ro/styles/city-celebration/256/{z}/{x}/{y}.png',
    // url: 'https://tiles.celebrare-timisoara.ro/styles/osm-bright/256/{z}/{x}/{y}.png',
    // url: 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}{r}.png',
    maxZoom: 20,

    attribution:
      '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap</a>',
    // detectRetina: true,
  },
  map: {
    zoomSnap: 0.5,
    minZoom: 13,
    maxZoom: 19,
  },
  cluster: {
    spiderfyDistanceMultiplier: 2.5,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: true,
    iconCreateFunction: (cluster) => {
      const count = cluster
        .getAllChildMarkers()
        .reduce((sum, value) => sum + value.options.icon.options.count, 0)

      return getIcon(count, [88, 88], 'is-cluster')
    },
  },
}

const openLocation = (location) => {
  active.value = location
}

const getIcon = (count, iconSize, className) => {
  return divIcon({
    html: `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64"><path fill="currentColor" d="m51.717 42.776 4.835 8.171-9.13-2.605 2.074 9.265-7.878-5.3-.892 9.453-5.854-7.474L31.102 63l-3.258-8.918-6.277 7.124-.343-9.489-8.171 4.835 2.605-9.13-9.265 2.074 5.3-7.878-9.453-.892 7.474-5.854L1 31.102l8.918-3.258-7.124-6.277 9.489-.343-4.835-8.171 9.13 2.605-2.074-9.265 7.878 5.3.892-9.453 5.854 7.474L32.898 1l3.258 8.918 6.277-7.124.343 9.489 8.171-4.835-2.605 9.13 9.265-2.074-5.3 7.878 9.453.892-7.474 5.854L63 32.898l-8.918 3.258 7.124 6.277z" /></svg><p>${count}</p>`,
    iconSize,
    iconAnchor: iconSize.map((e) => e / 2),
    className,
    count,
  })
}

const bounds = computed(() => {
  return props.data.locations.length
    ? new latLngBounds(props.data.locations.map((e) => [e.lat, e.long]))
    : new latLngBounds([
        [45.735375179956255, 21.18930357280082],
        [45.769772224274595, 21.263830647332476],
      ])
})

const onMapReady = (instance) => {
  mapInstance.value = instance
  instance.fitBounds(bounds.value.pad(0.15))
}

onMounted(() => {})

watch(
  () => props.data,
  () => {
    active.value = null
    mapInstance.value.fitBounds(bounds.value.pad(0.15))
  }
)
</script>

<template>
  <div id="map">
    <div class="columns is-mobile is-gapless">
      <div class="column is-narrow map-location-info" v-if="active">
        <IndexMapLocation v-bind="{ active }" @close="active = null" />
      </div>
      <div class="column">
        <l-map
          v-bind="{
            options: options.map,
            maxBounds: bounds.pad(0.5),
          }"
          @ready="onMapReady"
          v-if="bounds"
        >
          <l-tile-layer
            v-bind="options.tile"
            layer-type="base"
            name="OpenStreetMap"
          />
          <l-marker-cluster-group v-bind="{ ...options.cluster }">
            <l-marker
              v-for="marker in data.locations"
              :key="'marker-' + marker._id"
              :icon="
                getIcon(
                  marker.count,
                  [48, 48],
                  marker._id == active?._id ? 'is-active' : ''
                )
              "
              :lat-lng="[marker.lat, marker.long]"
              @click="openLocation(marker)"
            />
          </l-marker-cluster-group>
        </l-map>
      </div>
    </div>
  </div>
</template>
